



























import {Component, Mixins, Prop, Vue, Watch} from 'vue-property-decorator';
import JdhFieldStructure from "@/design-system/forms/shared/JdhFieldStructure.vue"
import {ActiveProvide} from "@/support/reactive"
import JdhLogicalRichRadioGroup from "@/design-system/forms/fields/JdhLogicalRichRadioGroup.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhValidationProvider from "@/design-system/forms/fields/JdhValidationProvider.vue"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdhErrorMessage from "@/design-system/forms/fields/JdhErrorMessage.vue"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 *  Add width and color options
 *  Add allow empty option
 */
@Component({
    components: {
        JdhErrorMessage,
        JdhHeightTransition,
        JdhValidationProvider, JdhLogicalRichRadioGroup, JdhFieldStructure}
})
export default class JdsRichRadioGroup extends Mixins(UniqueIdMixin) {
    @Prop() label!: string
    @Prop() value!: string

    @Prop({default: 'green', type: String}) color!: 'green'|'purple'
    @Prop({default: 'simple'}) layout!: 'simple'|'list'|'grid'
    @Prop({default: null}) columns!: number
    @Prop({type: Boolean, default: false}) required!: boolean
    @Prop({type: Boolean, default: false}) fullWidth!: boolean

    @ActiveProvide('jds.rich-radio.mode') provideMode = 'simple'
    @ActiveProvide('jds.rich-radio.color') provideColor = 'green'

    @Watch('mode', {immediate: true})
    syncMode() {
        this.provideMode = this.mode
    }

    @Watch('colors', {immediate: true})
    syncColor() {
        this.provideColor = this.colors
    }

    get rules () {
        return {
            ... (this.required && {required: { allowFalse: false }})
        }
    }

    get mode(): 'simple'|'list'|'grid-auto'|'grid-columns' {
        if (this.layout === 'simple') return 'simple'
        if (this.layout === 'list') return 'list'
        if (this.layout === 'grid' && !this.columns) return 'grid-auto'
        if (this.layout === 'grid' && this.columns) return 'grid-columns'
    }

    get colors(): 'green'|'purple' {
        if (this.color === 'green') return 'green'
        if (this.color === 'purple') return 'purple'
    }

    get mainClasses() {
        return {
            'jdsc-rich-radio-group__main--simple': this.mode === 'simple',
            'jdsc-rich-radio-group__main--list': this.mode === 'list',
            'jdsc-rich-radio-group__main--grid-auto': this.mode === 'grid-auto',
            'jdsc-rich-radio-group__main--grid-columns': this.mode === 'grid-columns',
        }
    }

    get mainStyles() {
        if (this.mode === 'grid-columns') {
            return {
                'grid-template-columns': `repeat(${this.columns}, 1fr)`,
            }
        }

        return {}
    }
}
